import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import {call, put, takeEvery} from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";

export type PostUserPersonalizationLoadAction = {
  type: string;
  payload: PersonalizationTypes;
};

export type PersonalizationTypes = {
  nickname?: string;
  job?: string;
  about?: string;
  interests?: string;
  instructions?: string;
  generated_images_quality?: string;
  generated_images_format?: string;
  generated_images_size?: string;
  generated_images_bg?: string;
  generated_video_quality?: string;
  generated_video_size?: string;
  generated_video_model?: string;
  generated_video_time?: string;
  narrator_voice?: string;
  language?: string;
  web_searching?: boolean | number;
  use_history?: boolean | number;
  allow_public_content?: boolean | number;
  dispatchCloseModal?: () => void;
};

export type PostUserPersonalizationData = {
  data: {
    message:string;
  };
};

const PostUserPersonalization = new ReduxFetchState<
  PostUserPersonalizationData | null, PersonalizationTypes,
  any
>("postUserPersonalization");

export function* watchPostUserPersonalization(
  action: PostUserPersonalizationLoadAction,
) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();
    let {dispatchCloseModal,...payloadData}=action.payload;

    const data: PostUserPersonalizationData = yield axios({
      url: `/api/v1/ai/user/personalization`,
      method: "POST",
      headers: {
        lang,
      },
      data: payloadData,
    });

    yield put(PostUserPersonalization.actions.loadSuccess({ data: data.data }));
    if (typeof dispatchCloseModal === "function") {
      yield call(dispatchCloseModal);
    }
    alert({
      message: data.data.message,
      type: "success",
    });
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(PostUserPersonalization.actions.loadFailure(e.message));
  }
}

export function* postUserPersonalizationSagas() {
  yield takeEvery(
    PostUserPersonalization.actionTypes.load,
    watchPostUserPersonalization,
  );
}

export function usePostUserPersonalization() {
  const { loading, data, ...postUserPersonalizationState } = useAppSelector(
    (state) => state.postUserPersonalization,
  );
  const dispatch = useAppDispatch();

  const dispatchPostUserPersonalization = useCallback(
    (data: PersonalizationTypes) => {
      dispatch(PostUserPersonalization.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...postUserPersonalizationState,
    dispatchPostUserPersonalization,
    postUserPersonalizationLoading: loading,
    postUserPersonalizationData: data,
  };
}

export const {
  actionTypes: postUserPersonalizationActionsTypes,
  actions: postUserPersonalizationActions,
  reducer: postUserPersonalizationReducer,
} = PostUserPersonalization;
